import type { CarouselQuoteComponent } from '@twisto/api-cms'

import { Hidden } from 'homepage/components/atoms/hidden'

import { StrapiMedia } from '../../atoms'

import * as styles from './quotes-carousel.styles'

export const Quote = ({
  text,
  image,
  name,
  position,
}: CarouselQuoteComponent) => (
  <div css={styles.quote}>
    <StrapiMedia {...image} css={styles.avatar} height={340} width={340} />
    <div css={styles.content}>
      <h3 css={styles.text}>{text}</h3>
      <div css={styles.details}>
        <span css={styles.name}>{name}</span>
        <Hidden breakpoint="smMdDown">
          <span css={styles.divider}> {'\u2013'} </span>
        </Hidden>
        <span css={styles.position}>{position}</span>
      </div>
    </div>
  </div>
)
